import { Store } from "pullstate";


export const LanStore = new Store({
    language:null
   });


export const msgStore = new Store({
    message:null
   });  
 
 